import { render, staticRenderFns } from "./tabs-box.vue?vue&type=template&id=09f6c3b4&"
import script from "./tabs-box.vue?vue&type=script&lang=js&"
export * from "./tabs-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports